import React from "react";
import { ExternalLink, Plus } from "lucide-react";
import { categories } from "../mock";

const Pill = ({ label, count, isActive, onClick, dotColor, external }) => (
  <button
    onClick={onClick}
    className={`group flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors duration-150 border ${
      isActive
        ? "bg-neutral-900 text-white border-neutral-900"
        : "bg-white text-neutral-700 border-neutral-200 hover:border-neutral-400"
    }`}
  >
    {dotColor && (
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: dotColor }} />
    )}
    <span>{label}</span>
    {typeof count === "number" && (
      <span className={isActive ? "text-neutral-300" : "text-neutral-400"}>({count})</span>
    )}
    {external && <ExternalLink className="h-3 w-3 opacity-60" />}
  </button>
);

const CategoryTabs = ({
  activeCategory,
  activeListId,
  counts,
  total,
  lists,
  onSelectCategory,
  onSelectList,
  onCreateList,
}) => {
  return (
    <div className="flex items-center gap-2 overflow-x-auto px-4 md:px-6 py-3 border-b border-neutral-200 bg-[#faf8f4] no-scrollbar">
      <Pill
        label="All"
        count={total}
        isActive={!activeListId && activeCategory === "all"}
        onClick={() => onSelectCategory("all")}
      />
      {categories.map((c) => (
        <Pill
          key={c.id}
          label={c.label}
          count={counts[c.id] || 0}
          dotColor={c.color}
          isActive={!activeListId && activeCategory === c.id}
          onClick={() => onSelectCategory(c.id)}
        />
      ))}

      {lists.length > 0 && (
        <div className="mx-1 flex items-center gap-2 pl-2">
          <span className="whitespace-nowrap text-xs font-semibold uppercase tracking-wide text-neutral-400">
            OG Lists
          </span>
          {lists.map((l) => (
            <Pill
              key={l.id}
              label={l.label}
              count={l.count}
              dotColor={l.is_community ? "#06d6a0" : "#c9b8a0"}
              isActive={activeListId === l.id}
              onClick={() => onSelectList(l.id)}
            />
          ))}
          <button
            onClick={onCreateList}
            className="flex items-center gap-1 whitespace-nowrap rounded-full border border-dashed border-neutral-300 bg-white px-3.5 py-1.5 text-sm font-medium text-neutral-600 transition-colors hover:border-neutral-500 hover:text-neutral-900"
          >
            <Plus className="h-3.5 w-3.5" /> New list
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryTabs;
